const LOGIN_DISPLAY_STORAGE_KEY = 'loginDisplay'
export const setLoginDisplay = (loginDisplay) => sessionStorage.setItem(LOGIN_DISPLAY_STORAGE_KEY, loginDisplay)
export const getLoginDisplay = () => sessionStorage.getItem(LOGIN_DISPLAY_STORAGE_KEY)